import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Span = styled.span`
  font-weight: ${props => props.theme.fontWeightBold};
  font-family: ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
  line-height: 120%;
  text-transform: uppercase;
`;

export default function NewMetricNumber({ n }) {
  const v = Number.isNaN(n) ? '-' : n.toLocaleString('en-US');
  return <Span>{v}</Span>;
}

NewMetricNumber.propTypes = { n: PropTypes.number.isRequired };
